
import {Component, Vue} from 'vue-property-decorator';
import HomeSidebarAds from "@/views/HomeSidebarAds.vue";
import {trackEvent} from "@/components/Analytics";
import {destroyGanalytics, installGanalytics} from "@/components/Tracker";



@Component({
  components: {HomeSidebarAds}
})

export default class Home2 extends Vue {
  public mounted() {
    window.onhashchange = () => {
      const id = location.hash.startsWith("#") ? location.hash.substring(1) : "top";
      document.getElementById(id).scrollIntoView()
    };
    installGanalytics();
    trackEvent("landing-v3");
  }

  public beforeDestroy() {
    destroyGanalytics();
  }
}
